import { createSelector } from "redux-starter-kit";

export default createSelector(
  ["invited.updateFactoringProfileSuccess"],
  payload => payload
);
